// src/components/Hero.jsx
import { Trans, useTranslation } from "react-i18next";
import HeroMock from "./HeroMock";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative">
      <div className="relative z-10 mx-auto max-w-7xl px-4 pt-16 pb-10">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight">
              <Trans i18nKey="hero.title_html">
                We design & build <span className="text-indigo-600">web apps</span> that ship fast and scale
              </Trans>
            </h1>

            <p className="mt-4 text-slate-600 text-lg">
              {t("hero.desc")}
            </p>

            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="#contact"
                className="rounded-xl bg-indigo-600 px-5 py-3 text-white font-medium transition-transform duration-200 hover:-translate-y-0.5 active:translate-y-0"
              >
                {t("hero.cta_estimate")}
              </a>
              <a
                href="#projects"
                className="rounded-xl px-5 py-3 font-medium border border-slate-300 hover:bg-slate-50 transition"
              >
                {t("hero.cta_projects")}
              </a>
            </div>

            <p className="mt-4 text-sm text-slate-500">
              {t("hero.tech_stack")}
            </p>
          </div>

          <div className="relative aspect-[16/10] w-full overflow-hidden rounded-2xl border border-slate-200 shadow-sm">
            <HeroMock />
          </div>
        </div>
      </div>
    </section>
  );
}
